// Pure mapping: sinistre statut -> Fiche panel progress step (4 steps).
// Statut vocabulary = StatutSinistre.java / STATUTS_SINISTRE (src/variables/constants.js).
// Grouping validated with BNCB domain owner (spec 2026-07-15).
import i18n from '../../i18n';

// Libellés lus dans la langue de l'interface au moment où on les parcourt :
// le tableau garde sa forme (STEP_LABELS[i], .map), le texte vit dans messagerie.json.
const ETAPES = ['ouverture', 'instruction', 'evaluation', 'reglement'];
export const STEP_LABELS = [];
ETAPES.forEach((cle, i) => Object.defineProperty(STEP_LABELS, i, {
  get: () => i18n.t(`messagerie:etapes.${cle}`),
  enumerable: true,
}));

const STEP_0 = ['NOUVEAU', 'VALIDE', 'GARANTIE_CONFIRMEE', 'REOUVERT'];
const STEP_1 = ['ATTENTE_PV', 'ATTENTE_RC', 'ATTENTE_PIECES_DE_RECLAMATION'];
const STEP_2 = ['MUR', 'ATTENTE_OFFRE', 'OFFRE_EFFECTUE', 'OFFRE_RECUE'];
const STEP_3 = [
  'ACCORD', 'REJET', 'BAP', 'ATTENTE_CHEQUE', 'CHEQUE_RECU',
  'PARTIELLEMENT_PAYE', 'SOLDE', 'CLOTURE',
];
const TERMINAL = ['GARANTIE_NON_ACQUISE', 'CONTENTIEUX', 'ARBITRAGE', 'SANS_SUITE'];

const GROUPS = [STEP_0, STEP_1, STEP_2, STEP_3];

export function statutToStep(statut) {
  const s = String(statut || '').toUpperCase();
  if (TERMINAL.includes(s)) return { index: -1, terminal: true };
  for (let i = 0; i < GROUPS.length; i++) {
    if (GROUPS[i].includes(s)) return { index: i, terminal: false };
  }
  return { index: -1, terminal: false };
}
